import createEditKeyFobRedux from 'Modules/keysFobs/.components/createEditKeyFob/redux/reducer';
import deleteKeyFobRedux from 'Modules/keysFobs/.components/deleteKeyFob/redux/reducer';
import bulkAddDriverIdTagsRedux from 'Modules/keysFobs/.components/bulkAddDriverIdTags/redux/reducer';
import moveToAnotherAccountRedux from 'Modules/keysFobs/.components/moveToAnotherAccount/redux/reducer';
import unassignDriversRedux from 'Modules/keysFobs/.components/unassignDrivers/redux/reducer';



//export redux objects
export default {
	createEditKeyFobRedux,
	deleteKeyFobRedux,
	bulkAddDriverIdTagsRedux,
	moveToAnotherAccountRedux,
	unassignDriversRedux,
};